import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import Button from '../../components/common/Button';
import EmptyState from '../../components/common/EmptyState';

const NotFoundPage = () => (
  <div className="min-h-[60vh] flex items-center justify-center p-6">
    <div className="max-w-md w-full">
      <EmptyState
        icon={Compass}
        title="Página não encontrada"
        description="A página que você tentou acessar não existe ou foi movida."
        action={
          <Link to="/">
            <Button>Voltar pra home</Button>
          </Link>
        }
      />
    </div>
  </div>
);

export default NotFoundPage;
